import { component } from "picoapp";
import { getHeaderHeights } from "../../utilities";

export const productAnchorButton = component((node: HTMLElement) => {
  const anchorSectionName = node.dataset.anchorSection;
  const anchorIndex = node.dataset.anchorIndex;
  const anchorElement = node.querySelector<HTMLAnchorElement>("a");

  if (!anchorIndex || !anchorSectionName || !anchorElement) return;

  const sectionElement = document.querySelectorAll<HTMLElement>(
    ".shopify-section" + `.section-${anchorSectionName}`
  );
  const anchorSectionElement = sectionElement[parseInt(anchorIndex)];

  const handleScroll = (e: MouseEvent) => {
    e.preventDefault();
    anchorSectionElement.style.scrollMarginTop = `${getHeaderHeights()}px`;
    anchorSectionElement.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "start",
    });
  };

  if (sectionElement) {
    node.addEventListener("click", handleScroll);
  }

  return () => {
    if (sectionElement) {
      node.removeEventListener("click", handleScroll);
    }
  };
});
